export default {
  CATCHUP: 'CATCHUP',
  EPISODE: 'EPISODE',
  LIVE: 'LIVE',
  RECORDING: 'RECORDING',
  TRAILER: 'TRAILER',
  MOVIE: 'MOVIE',
};
